<template>
  <section class="layout" :style="{minHeight: overHeight + 'px'}">
    <div class="layout-top">
      <mul-head class="layout-header">
        <template v-slot:logo> 
          <div class="layout-header-logo">
            <router-link to="/">
              <img src='../assets/phlogo.png' />
            </router-link>
          </div>
        </template>
        <template v-slot:nav>
          <mul-nav class="layout-header-nav" :navList="navList"/>
        </template>
      </mul-head>
    </div>
    <div class="layout-view">
      <router-view :key="key" />
    </div>
    <div class="layout-bot">
      <mul-foot class="layout-footer">
        <div slot="ba-copy" class="layout-footer-copy">
          <!-- <a class="copy" href="http://beian.miit.gov.cn/">Copyright © 2011-2021 超级双开助手 All Rights Reserved 沪ICP备17016778号-1</a> -->
          <!-- <a class="copy" href="http://beian.miit.gov.cn/">Copyright © 2011-2021 超级双开助手 All Rights Reserved 皖ICP备2021010536号-1</a> -->
          <a class="copy" href="http://beian.miit.gov.cn/">版权所有 © 合肥摩仓电子商务有限公司 © 皖ICP备2021010536号-1</a>
        </div>
      </mul-foot>
    </div>
  </section>
</template>

<script>
import mulHead from '@/components/Head.vue'
import mulNav from '@/components/Nav.vue'
import mulFoot from '@/components/Foot.vue'
export default {
  components: {
    mulHead,
    mulNav,
    mulFoot
  },
  props: {},
  data () {
    return {
      overHeight: window.innerHeight,
      navList: [{
        path: '/',
        name: 'home',
        text: '网站首页'
      }, {
        path: '/reports',
        name: 'reports',
        text: '关于我们'
      },
      {
        path: '/down',
        name: 'down',
        text: '软件下载'
      }
      ]
    }
  },
  watch: {},
  computed: {
    key() {
      return this.$route.path
    }
  },
  methods: {},
  created () {},
  mounted () {}
}
</script>
<style scoped>
.layout {
  min-width: 1200px;
}
.layout-top {
  width: 100%;
  background: #222222;
}
.layout-header {
  height: 70px;
  padding: 0 88px;
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}
.layout-header-logo {
  float: left;
  line-height: 36px;
}
.layout-header-logo img{
  margin-top: 15px;
  float: left;
}
.layout-header-logo span {
  float: left;
  color: #fff;
  font-size: 24px;
  margin-left: 20px;
  font-weight: 500;
}
.layout-header-nav {
  float: right;
}
.layout-bot {
  width: 100%;
}
.layout-footer-copy {
  width: 100%;
  height: 200px;
  position: absolute;
  background-color: #F1F1F1;
  color: rgba(255, 255, 255);
  text-align: center;
  line-height: 50px;
  font-size: 14px;
}
.layout-view {
  /* width: 1200px; */
  margin: 0 auto;
}
.layout-bot {
  height: 50px;
}
.copy {
    color: #666666;
    margin-top: 100px;
}
.police {
  vertical-align: middle;
}
.layout-footer-copy a {
  display: block;
  height: 40px;
}
</style>